<template>
  <section class="container error">
    <div class="text-center error--con">
      <img src="@/assets/images/common/warning.png" alt="!" class="mb-2">
      요청하신 페이지를 찾을 수 없습니다
    </div>
  </section>
</template>

<script>
export default {
  name: 'Error404',
};
</script>

<style lang='scss' scoped>
.error{
  font-size: 2rem;
  color: #999999;
  height: 40rem;
  display: table;
  &--con{
    display: table-cell;
    vertical-align: middle;
  }
  img{
    display: block;
    margin: auto;
  }
}
</style>
